import { MdEngineering, MdFactory, MdAgriculture, MdSecurity } from "react-icons/md";
import "./index.css";
import { useRevealOnScroll } from "../../hooks/Reveal/useRevealOnScroll.tsx";

export function Industries() {
 useRevealOnScroll();
  const industries = [
    {
      name: "Construction",
      desc: "Manage multiple crews and sites.",
      icon: <MdEngineering size={36} />,
      tone: "orange",
    },
    {
      name: "Mining & Heavy Industry",
      desc: "Operate reliably in harsh environments.",
      icon: <MdFactory size={36} />,
      tone: "yellow",
    },
    {
      name: "Agriculture",
      desc: "Track seasonal and contract workers.",
      icon: <MdAgriculture size={36} />,
      tone: "green",
    },
    {
      name: "Security & Cleaning",
      desc: "Mobile teams clock in on the move.",
      icon: <MdSecurity size={36} />,
      tone: "blue",
    },
  ];

  return (
    <section id="industries" className="section section--alt">
      <div className="container">
        <h2 className="section__title">Made for worksites</h2>
        <div className="industry-grid">
          {industries.map(({ name, desc, icon, tone }) => (
            <div key={name} className={`industry-card industry-card--${tone}`}>
              <div className="industry-icon">{icon}</div>
              <h3 className="industry-title">{name}</h3>
              <p className="industry-text">{desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
